import styled from 'styled-components';

export const AddressWithMapWrapper = styled.div`
  width: 100%;
`;
